import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-cream" data-id="element-179">
      <div className="max-w-3xl mx-auto" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-181">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-navy" data-id="element-182">
            Does any of this sound familiar?
          </h2>
          <p className="text-lg text-navy-light leading-relaxed bg-white p-6 rounded-2xl border border-navy/10 shadow-sm" data-id="element-183">
            It is Sunday at 10 PM. You have Spanish class tomorrow. And you are
            still staring at a blank PowerPoint, searching Pinterest for an
            activity that actually works, wondering if there is a better way.
            <br data-id="element-184" />
            <br data-id="element-185" />
            <span className="text-turquoise font-bold" data-id="element-186">
              You are not the problem.
            </span>{' '}
            The problem is that for years you have been fighting with
            disconnected resources, dense grammar explanations, and materials
            designed for completely different contexts that you have to rewrite
            from scratch every single time.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-187">
          <h3 className="text-xl font-bold text-navy mb-8 text-center" data-id="element-188">
            The real cost of not having the right materials:
          </h3>

          <ul className="space-y-4" data-id="element-189">
            {['Sleepless nights trying to turn complex Spanish grammar into language your students can actually understand', 'Improvised lessons because you could not find clear, ready-to-use material in time', 'Disengaged students who feel like Spanish has nothing to do with their real life', 'Uncomfortable silences when a student asks the difference between the preterite and the imperfect and you do not have a crisp answer ready', 'Weekends lost building lesson plans, activities, and assessments from zero — over and over again', 'Substitute days that turn into chaos because you have no emergency resources prepared', 'Heritage speakers who feel invisible because your materials do not reflect their culture'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-white p-4 rounded-xl border border-red-100 shadow-sm" data-id="element-190">
                <span className="text-red-500 mt-1" data-id="element-191">🔴</span>
                <span className="text-navy-light" data-id="element-192">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-navy/10" data-id="element-193">
            <p className="text-2xl font-serif font-bold text-turquoise-gradient" data-id="element-194">
              Stop giving away your free time. Your dedication is already there.
              What you have been missing is the tool.
            </p>
            <p className="text-xl mt-4 text-navy font-medium" data-id="element-195">
              Plan your entire year today.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}